export default __webpack_public_path__ + "static/media/titanic.d7a67c1c.jpeg";